export default __webpack_public_path__ + "content/0e63c9e707bdfbcda3077baa43a7484a.ttf";